import initFooterContactFormSubmit from './footerContactFormSubmit';
import initFooterInputEvents from './footerInputEvents';

export default () => {
  initFooterContactFormSubmit();
  initFooterInputEvents();
};
